"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M250.5 83.3V46c0-9.4 11.2-14 17.7-7.3l58.3 58.1c4.2 4.2 4.2 10.6 0 14.8l-58.1 58.1c-6.7 6.5-17.9 1.9-17.9-7.5V125c-69 0-125 56-125 125 0 16.5 3.1 32.5 9.2 46.9 3.1 7.5.8 16-4.8 21.7-10.6 10.6-28.5 6.9-34.2-7.1-7.7-19-11.9-39.8-11.9-61.5 0-92.1 74.6-166.7 166.7-166.7zm0 291.7c69 0 125-56 125-125 0-16.5-3.1-32.5-9.2-46.9-3.1-7.5-.8-16 4.8-21.7 10.6-10.6 28.5-6.9 34.2 7.1 7.7 19 11.9 39.8 11.9 61.5 0 92.1-74.6 166.7-166.7 166.7V454c0 9.4-11.2 14-17.7 7.3l-58.1-58.1c-4.2-4.2-4.2-10.6 0-14.8l58.1-58.1c6.5-6.5 17.7-1.9 17.7 7.5V375z"
  });
};

exports.default = _default;